"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var interfaces_1 = require("./interfaces");
var SimpleSlider = /** @class */ (function (_super) {
    __extends(SimpleSlider, _super);
    function SimpleSlider(options) {
        var _this = _super.call(this) || this;
        _this.interval = null;
        _this.intervalStartTime = null;
        _this.updateConfig(options);
        var boundChange = _this.visibilityChange.bind(_this);
        // configures visibility api handler https://developer.mozilla.org/en-US/docs/Web/API/Page_Visibility_API
        document.addEventListener("visibilitychange", boundChange);
        if (_this.imgs && _this.imgs.length > 1) {
            _this.resume();
        }
        _this.animate = _this.animate.bind(_this);
        _this.change = _this.change.bind(_this);
        _this.dispose = _this.dispose.bind(_this);
        _this.getCurrentIndex = _this.getCurrentIndex.bind(_this);
        _this.isAutoPlay = _this.isAutoPlay.bind(_this);
        _this.next = _this.next.bind(_this);
        _this.nextIndex = _this.nextIndex.bind(_this);
        _this.pause = _this.pause.bind(_this);
        _this.prev = _this.prev.bind(_this);
        _this.prevIndex = _this.prevIndex.bind(_this);
        _this.reset = _this.reset.bind(_this);
        _this.resume = _this.resume.bind(_this);
        _this.reverse = _this.reverse.bind(_this);
        _this.setAutoPlayLoop = _this.setAutoPlayLoop.bind(_this);
        _this.setupSlides = _this.setupSlides.bind(_this);
        _this.updateConfig = _this.updateConfig.bind(_this);
        _this.visibilityChange = _this.visibilityChange.bind(_this);
        return _this;
    }
    SimpleSlider.prototype.change = function (newIndex) {
        var _a = this, actualIndex = _a.actualIndex, imgs = _a.imgs;
        imgs.forEach(function (image, index) {
            var zIndex = index === newIndex ? "103"
                : index === actualIndex ? "102"
                    : "101";
            image.style.zIndex = zIndex;
        });
        this.animate(imgs[actualIndex], imgs[newIndex], 0, 0);
        this.actualIndex = newIndex;
        if (this.onChange) {
            this.onChange(this.prevIndex(), actualIndex);
        }
    };
    SimpleSlider.prototype.dispose = function () {
        clearTimeout(this.interval);
        var boundChange = this.visibilityChange.bind(this);
        document.removeEventListener("visibilitychange", boundChange);
        this.actualIndex = null;
        this.children = null;
        this.containerElem = null;
        this.delay = null;
        this.endVal = null;
        this.imgs = null;
        this.interval = null;
        this.intervalStartTime = null;
        this.onChange = null;
        this.onChangeEnd = null;
        this.paused = null;
        this.remainingTime = null;
        this.startVal = null;
        this.trProp = null;
        this.trTime = null;
        this.unit = null;
        this.visVal = null;
    };
    SimpleSlider.prototype.getCurrentIndex = function () {
        return this.actualIndex;
    };
    SimpleSlider.prototype.next = function () {
        this.change(this.nextIndex());
        this.resume();
    };
    SimpleSlider.prototype.nextIndex = function () {
        var _a = this, actualIndex = _a.actualIndex, imgs = _a.imgs;
        var newIndex = actualIndex + 1;
        return newIndex >= imgs.length
            ? 0
            : newIndex;
    };
    SimpleSlider.prototype.pause = function () {
        var _a = this, delay = _a.delay, intervalStartTime = _a.intervalStartTime, interval = _a.interval;
        if (this.isAutoPlay.call(this)) {
            this.remainingTime = delay - (Date.now() - intervalStartTime);
            clearTimeout(interval);
            this.interval = 0;
        }
    };
    SimpleSlider.prototype.prev = function () {
        this.change(this.prevIndex());
        this.resume();
    };
    SimpleSlider.prototype.prevIndex = function () {
        var _a = this, actualIndex = _a.actualIndex, imgs = _a.imgs;
        var newIndex = actualIndex - 1;
        return newIndex < 0
            ? imgs.length - 1
            : newIndex;
    };
    SimpleSlider.prototype.reset = function (prevTrProp) {
        var _a = this, children = _a.children, containerElem = _a.containerElem, delay = _a.delay, startVal = _a.startVal, trProp = _a.trProp, unit = _a.unit, visVal = _a.visVal;
        if (children.length > 0) {
            var style = containerElem.style;
            style.position = "relative";
            style.overflow = "hidden";
            style.display = "block";
            this.actualIndex = 0;
            this.imgs = this.setupSlides(containerElem, children, unit, startVal, visVal, trProp, prevTrProp);
            this.remainingTime = delay;
        }
    };
    SimpleSlider.prototype.resume = function () {
        var interval = this.interval;
        if (this.isAutoPlay.call(this)) {
            if (interval) {
                clearTimeout(interval);
            }
            this.setAutoPlayLoop();
        }
    };
    SimpleSlider.prototype.reverse = function () {
        var _a = this, actualIndex = _a.actualIndex, endVal = _a.endVal, imgs = _a.imgs, startVal = _a.startVal;
        var newEndVal = startVal;
        this.startVal = endVal;
        this.endVal = newEndVal;
        this.actualIndex = Math.abs(actualIndex - (imgs.length - 1));
        this.imgs = imgs.reverse();
    };
    SimpleSlider.prototype.updateConfig = function (options, withResume) {
        var defaultEase = function (time, begin, change, duration) { return ((time = time / (duration / 2)) < 1)
            ? change / 2 * time * time * time + begin
            : change / 2 * ((time -= 2) * time * time + 2) + begin; };
        var children = options.children, containerElem = options.containerElem, delay = options.delay, ease = options.ease, endVal = options.endVal, onChange = options.onChange, onChangeEnd = options.onChangeEnd, paused = options.paused, startVal = options.startVal, trProp = options.trProp, trTime = options.trTime, unit = options.unit, visVal = options.visVal;
        var prevTrProp = this.trProp;
        var getDef = function (val, def) { return val === null || val === undefined
            ? def : val; };
        this.containerElem = getDef(containerElem, document.querySelector("*[data-simple-slider]"));
        this.children = (children && children.length) ? children : this.containerElem.children;
        this.delay = getDef(delay, 3) * 1000;
        this.ease = getDef(ease, defaultEase);
        this.endVal = getDef(endVal, 100);
        this.onChange = getDef(onChange, null);
        this.onChangeEnd = getDef(onChangeEnd, null);
        this.paused = paused;
        this.startVal = getDef(startVal, -100);
        this.trProp = getDef(trProp, "left");
        this.trTime = getDef(trTime, 0.5) * 1000;
        this.unit = getDef(unit, "%");
        this.visVal = getDef(visVal, 0);
        this.reset(prevTrProp);
        if (withResume && this.imgs && this.imgs.length > 1) {
            this.resume();
        }
    };
    SimpleSlider.prototype.animate = function (insertElem, removeElem, startTime, elapsedTime) {
        var _a = this, actualIndex = _a.actualIndex, ease = _a.ease, endVal = _a.endVal, startVal = _a.startVal, trProp = _a.trProp, trTime = _a.trTime, unit = _a.unit, visVal = _a.visVal;
        var animate = this.animate;
        var setProp = function (elem, from, to) {
            elem.style[trProp] = ease(elapsedTime - startTime, from, to - from, trTime) + unit;
        };
        if (startTime > 0) {
            if (elapsedTime - startTime < trTime) {
                setProp(insertElem, visVal, endVal);
                setProp(removeElem, startVal, visVal);
            }
            else {
                insertElem.style[trProp] = endVal + unit;
                removeElem.style[trProp] = visVal + unit;
                if (this.onChangeEnd) {
                    this.onChangeEnd(actualIndex, this.nextIndex());
                }
                return;
            }
        }
        requestAnimationFrame(function (time) {
            // Starts time in the first anim iteration
            var newStartTime = startTime === 0 ? time : startTime;
            animate(insertElem, removeElem, newStartTime, time);
        });
    };
    SimpleSlider.prototype.isAutoPlay = function () {
        return !this.paused && this.imgs && this.imgs.length > 1;
    };
    SimpleSlider.prototype.playLoop = function () {
        this.intervalStartTime = Date.now();
        this.remainingTime = this.delay; // resets time, used by pause/resume logic
        this.change(this.nextIndex());
        // loops
        this.setAutoPlayLoop();
    };
    SimpleSlider.prototype.setAutoPlayLoop = function () {
        this.intervalStartTime = Date.now();
        var boundLoop = this.playLoop.bind(this);
        this.interval = window.setTimeout(boundLoop, this.remainingTime);
    };
    SimpleSlider.prototype.setupSlides = function (containerElem, children, unit, startVal, visVal, trProp, prevTrProp) {
        return Array.prototype.slice.call(children).map(function (child, index) {
            var indexZero = index === 0;
            var zIndex = indexZero ? "1" : "0";
            var trVal = (indexZero ? visVal : startVal) + unit;
            if (prevTrProp) {
                child.style[prevTrProp] = "inherit";
            }
            child.style.position = "absolute";
            child.style.top = "inherit";
            child.style.left = "inherit";
            child.style.zIndex = zIndex;
            child.style[trProp] = trVal;
            return child;
        });
    };
    SimpleSlider.prototype.visibilityChange = function () {
        if (document.hidden) {
            this.pause();
        }
        else {
            this.resume();
        }
    };
    return SimpleSlider;
}(interfaces_1.SliderClass));
exports.default = SimpleSlider;
//# sourceMappingURL=simpleslider.js.map